import { FILE_EXTENSION } from "constants/index";

const fileNameBuilder = (title, type) => `${title}${FILE_EXTENSION[type]}`;

export { fileNameBuilder };
